/**
 * shared.tsx — Component and type exports for lead-detail.
 * Constants and helpers are in shared-constants.ts.
 * This file should ONLY export types and components, not constants.
 */

// Re-export all types from the API client
export type {
  LeadStage,
  LeadDecision,
  LeadDetail,
  LeadMessage,
  LeadEvent,
  ShowingAppointment,
  ShowingKind,
  ShowingOutcome,
  RsvpStatus,
  VerificationTask,
  VerificationKind,
  VerificationStatus,
  ScreeningCriteria,
  Applicant,
  ApplicantRole,
  AppointmentProposal,
  SharedApplicantData,
  ResidentialHistoryEntry,
  OtherIncomeEntry,
  RecurringDebtEntry,
  VehicleEntry,
  PersonalReferenceEntry,
  EmergencyContactEntry,
  CriminalDisclosureEntry,
} from '../../../lib/leasing.api';

// ---------------------------------------------------------------------------
// InfoRow — shared display component used in ApplicantDetailPanel
// ---------------------------------------------------------------------------

interface InfoRowProps {
  label: string;
  value: string;
}

export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-xs text-muted-foreground">{label}</span>
      <span className="text-sm text-foreground">{value}</span>
    </div>
  );
}
